<template>
  <el-dialog :visible.sync="visible" :title="$t('update')" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <template>获取二级章数量</template>
      <template>
        <el-select v-model="dataForm.rule" placeholder="请选择">
          <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
          </el-option>
        </el-select>
      </template>
      <template><el-input-number v-model="dataForm.num" @change="handleChange" :min="1" :max="100" label="描述文字"></el-input-number>
      </template>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  components: {},
  data () {
    return {
      visible: false,
      dataForm: {
        ruleDecorationId: '',
        rule: '',
        num: ''
      },
      options: [{
        value: '0',
        label: '大于等于'
      }, {
        value: '1',
        label: '大于',
        disabled: true
      }, {
        value: '2',
        label: '小于等于'
      }, {
        value: '3',
        label: '小于'
      }, {
        value: '4',
        label: '等于'
      }],
      form: {
        ruleDecorationId: ''
      }

    }
  },
  computed: {
    dataRule () {
      return {
        paramsValue: [
          { required: true, message: '参数不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.form.ruleDecorationId) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/yqtsz/ruledecoration/' + this.form.ruleDecorationId).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.ruleDecorationId = this.form.ruleDecorationId
        this.$http.post('/yqtsz/ruledecoration/updateRule/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
